export default {
  namespaced: true,
  state: () => ({
    selectedEmployees: []
  }),
  getters: {
    selectedEmployees: (state) => state.selectedEmployees
  },
  mutations: {
    SET_SELECTED_EMPLOYEES (state, employees) {
      state.selectedEmployees = employees
    }
  },
  actions: {
    setSelectedEmployees ({ commit }, employees) {
      commit('SET_SELECTED_EMPLOYEES', employees)
    }
  }
}
